<template lang="pug">
  .property
    label(v-if="showLabel") {{ property.name }}
    .values
      template(v-if="property.type === 'color'")
        // TODO: check for image swatch
        .color-value(v-for="el in property.values")
          template(v-if="el.value_alt")
            span.color-tile(:style="{ background: el.value_alt }")
          template(v-else) {{ el.value }}
      template(v-else)
        .text-value(v-for="el in property.values")
          | {{ el.value }}
</template>

<script>
export default {
  name: 'TeaserProperty',
  props: {
    property: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="sass" scoped>
.property
  font-size: .85rem
  line-height: 1.2
  .values
    margin-left: -2px
    height: 18px
    overflow-y: hidden
    overflow-x: scroll
    scrollbar-width: none
    -ms-overflow-style: none
    &::-webkit-scrollbar
      display: none
  .color-value
    display: inline-block
    margin: 0 2px
    .color-tile
      @apply border-1 border-gray-400
      display: block
      width: 18px
      height: 18px
</style>
